<ng-container *ngIf="!isMultiselectView">
	<button class="typeahead--select-all link-c def-focus" *ngIf="options.selectAll" (click)="selectAll($event)">
		{{ 'reports.select_all' | translate }}
	</button>
	<div
		class="typeahead"
		[ngClass]="{
			'typeahead--is-focused': isFocused,
			'is-invalid': !isValid(),
			'typeahead--disabled': options.disabled
		}">
		<ul
			class="selected-list"
			[ngClass]="{
				'selected-list--is-scrollable': isScrollable
			}"
			(click)="focusInput(input)"
			#list>
			<li
				[attr.aria-live]="liveAnnouncer ? 'assertive' : 'off'"
				aria-atomic="true"
				[attr.aria-label]="liveAnnouncer"></li>
			<ng-container *ngIf="!options.hideChips">
				<li *ngFor="let sel of internalSelectedValues; let i = index">
					<lu-typeahead-chip-wrapper
						[options]="options.chipOptions"
						[chipsLength]="internalSelectedValues.length"
						[index]="i"
						[data]="sel"
						[closeCallback]="removeSelectedItem.bind(this, sel)">
					</lu-typeahead-chip-wrapper>
				</li>
			</ng-container>
			<li>
				<input
					class="input-search"
					#inputSearch
					(keyup)="inputChange$.next({ value: inputSearch.value, key: $event.key })"
					(blur)="onBlur()"
					[attr.aria-label]="options | getSearchInputAriaLabel: internalSelectedValues : selectedAll"
					[id]="options.id"
					autocomplete="off"
					(focus)="loadDataOnFocus()"
					[placeholder]="searchPlaceholder"
					(click)="setCursor()"
					[disabled]="options.disabled"
					[readonly]="options.readonly"
					[ngClass]="{
						hdn: (options.maxSelections && options.maxSelections === internalSelectedValues.length) || selectedAll
					}"
					#input />
				<span class="sizer"></span>
			</li>
			<ng-container *ngIf="loadingData | async">
				<span class="loading-icon">
					<lu-icon class="lui" icon="spinner"></lu-icon>
				</span>
			</ng-container>
		</ul>
		<section
			class="result-list"
			[ngClass]="{
				'is-focused': isFocused,
				'result-list--initially-open': !!alwaysOpen,
				'result-list--initially-closed': !alwaysOpen,
				'result-list--as-popover': !!isAbsolute,
				'result-list--ddm-open': dropdownOpened
			}">
			<ng-container *ngIf="(items | async)?.length > 0; else emptyState">
				<ul
					class="result-list__bd"
					luInfiniteScroll
					(scrolled)="onScrollDown()"
					#listContainer
					[ngClass]="{
						disabled: (options.maxSelections && options.maxSelections === internalSelectedValues.length) || selectedAll
					}">
					<li
						class="result-list__item"
						*ngFor="
							let item of items
								| async
								| alreadyAddedValues: selectedValues : refreshAlreadyAddedValuesFilter : selectAs;
							let i = index;
							trackBy: trackByFn
						"
						(mousedown)="handleOptionClicked(item, $event)"
						#singleItemEl
						aria-atomic="true"
						[attr.aria-live]="isActive(item, i) ? 'polite' : 'off'"
						[ngClass]="{ active: isActive(item, i) }"
						(mouseenter)="onHover(i)">
						<lu-typeahead-item-wrapper [options]="options.itemOptions" [data]="item"> </lu-typeahead-item-wrapper>
					</li>
				</ul>

				<footer class="result-list__ft">
					<div class="loading-list" *ngIf="loadingData | async">
						{{ 'lup.typeahead.loading' | translate }}
					</div>
					<ul class="keyboard-shortcuts">
						<li>
							<lu-icon class="lui" icon="long-arrow-left"></lu-icon>
							<span>{{ 'lup.typeahead.delete_item' | translate }}</span>
						</li>
						<li>
							<lu-icon class="lui" icon="caret-up"></lu-icon>
							<span>{{ 'lup.typeahead.go_up' | translate }}</span>
						</li>
						<li>
							<lu-icon class="lui" icon="caret-down"></lu-icon>
							<span>{{ 'lup.typeahead.go_down' | translate }}</span>
						</li>
						<li>
							<lu-icon class="lui lui--rotate-90" icon="level-down"></lu-icon>
							<span>{{ 'lup.typeahead.add_item' | translate }}</span>
						</li>
					</ul>
				</footer>
			</ng-container>
		</section>
	</div>
</ng-container>

<!-- MULTI SELECT VIEW -->
<ng-container *ngIf="isMultiselectView">
	<div
		class="multiselect"
		[ngClass]="{
			'typeahead--is-focused': isFocused && !options.disabled,
			'is-invalid': !isValid(),
			'multiselect--disabled': options.disabled
		}"
		(blur)="multiselectBlur()"
		[id]="searchPlaceholder + '_multiselect'">
		<div
			class="multiselect__control"
			tabindex="{{ options.disabled ? -1 : 0 }}"
			[attr.aria-disabled]="options.disabled"
			(keyup.space)="$event.stopPropagation(); multiselectLoadDataOnFocus()"
			(keyup.enter)="$event.stopPropagation(); multiselectLoadDataOnFocus()"
			(click)="multiselectLoadDataOnFocus()">
			<div class="o-flex o-flex--vcenter">
				<span *ngIf="internalSelectedValues?.length" class="multiselect__selection">
					{{ internalSelectedValues.length }}
				</span>
				<span class="multiselect__text">
					{{ searchPlaceholder }}
				</span>
			</div>

			<div class="o-flex">
				<lu-icon
					icon="lu-clear"
					*ngIf="showFilterClear && internalSelectedValues?.length && !options.disabled"
					role="button"
					tabindex="0"
					(keyup.space)="$event.stopPropagation(); clearSelection(); multiselectClearInitialSelection()"
					(keyup.enter)="$event.stopPropagation(); clearSelection(); multiselectClearInitialSelection()"
					(click)="$event.stopPropagation(); clearSelection(); multiselectClearInitialSelection()"
					[title]="'reset all' | translate"></lu-icon>
				<lu-icon [type]="LuIconType.SOLID" icon="lu-chevron-down" [ngClass]="{ 'fa-rotate-180': dropdownOpened }">
				</lu-icon>
			</div>
		</div>

		<!-- DROPDOWN -->
		<div class="multiselect__dropdown" [class.multiselect__dropdown--absolute]="isAbsolute" *ngIf="dropdownOpened">
			<!-- SEARCH -->
			<input
				#multiselectSearch
				class="multiselect__search"
				(keyup)="inputChange$.next({ value: multiselectSearch.value, key: $event.key })"
				[attr.aria-label]="
					options?.maxSelections === internalSelectedValues.length || selectedAll
						? ('lup.typeahead.guidance_max_selected' | translate)
						: options.disabled || options.readonly
							? ('lup.a11y.typeahead.guidance_disabled' | translate)
							: ('lup.typeahead.guidance' | translate)
				"
				[id]="options.id"
				autocomplete="off"
				[placeholder]="'search' | translate"
				(click)="setCursor()"
				[disabled]="options.disabled"
				[readonly]="options.readonly"
				[ngClass]="{
					hdn: options?.maxSelections === internalSelectedValues.length || selectedAll
				}" />

			<!-- DROPDOWN LIST -->
			<ul class="result-list__bd" luInfiniteScroll (scrolled)="onScrollDown()" #listContainer>
				<!-- SELECTED OPTIONS -->
				<li
					class="multiselect__item"
					*ngFor="let item of internalSelectedValues; let i = index; trackBy: trackByFn"
					(click)="$event.preventDefault(); $event.stopPropagation(); removeSelectedItem(item)">
					<span>
						<input type="checkbox" [checked]="true" />
						<lu-typeahead-item-wrapper [options]="options.itemOptions" [data]="item"> </lu-typeahead-item-wrapper>
					</span>
				</li>

				<!-- AVAILABLE OPTIONS -->
				<ng-container *ngIf="(items | async)?.length > 0; else emptyState">
					<li
						class="multiselect__item"
						*ngFor="
							let item of items
								| async
								| alreadyAddedValues: selectedValues : refreshAlreadyAddedValuesFilter : selectAs;
							let i = index;
							trackBy: trackByFn
						"
						(click)="$event.preventDefault(); $event.stopPropagation(); handleOptionClicked(item, $event)"
						aria-atomic="true"
						[ngClass]="{
							disabled: options?.maxSelections === internalSelectedValues.length || selectedAll
						}"
						(mouseenter)="onHover(i)">
						<span>
							<input type="checkbox" [checked]="false" />
							<lu-typeahead-item-wrapper [options]="options.itemOptions" [data]="item"> </lu-typeahead-item-wrapper>
						</span>
					</li>
				</ng-container>
			</ul>

			<!-- FOOTER -->
			<footer *ngIf="showFooterActions" class="multiselect__footer">
				<button
					[id]="generateButtonId('clear')"
					*ngIf="isSelectionUnchanged()"
					(click)="$event.stopPropagation(); multiselectClearSelection()"
					[disabled]="!internalSelectedValues.length && !initialSelectionState.length"
					class="btn btn-ghost">
					{{ 'date.clear' | translate }}
				</button>
				<button
					[id]="generateButtonId('cancel')"
					*ngIf="!isSelectionUnchanged()"
					(click)="$event.stopPropagation(); cancelSelection()"
					class="btn btn-ghost">
					{{ 'pages.cancel' | translate }}
				</button>
				<button
					[id]="generateButtonId('apply')"
					(click)="applySelection()"
					[disabled]="(!internalSelectedValues.length && !initialSelectionState.length) || isSelectionUnchanged()"
					class="btn btn-theme">
					{{ 'lup.filters.apply' | translate }}
				</button>
			</footer>
		</div>
	</div>
</ng-container>

<!-- NULL STATE (shared for both views)-->
<ng-template #emptyState>
	<div *ngIf="!firstLoad" class="empty">
		<div class="state">
			<div class="state-icon">
				<lu-icon class="lui" icon="search"></lu-icon>
			</div>
			<div class="state-title">
				{{ 'lup.typeahead.no_results_found' | translate }}
			</div>
		</div>
	</div>
</ng-template>
